module.exports = __webpack_public_path__ + "static/media/bg-rays-palm.3d6c1b7a.svg";